import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --nido-ink: #24353b;
    --nido-blue: #2f7088;
    --nido-terracotta: #c66f4e;
    --nido-orange: #f2a33b;
    --nido-ivory: #f7f6f1;
    --nido-paper: #fcfbf8;
    --nido-line: #dce4e3;
    --nido-muted: #69777a;
  }

  *, *::before, *::after {
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  html, body, #root {
    width: 100%;
    min-height: 100%;
  }

  html {
    overflow-x: clip;
    -webkit-text-size-adjust: 100%;
    background: ${({ theme }) => theme.colors.background};
  }

  body {
    margin: 0;
    overflow-x: clip;
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  h1, h2, h3, h4, p {
    margin-top: 0;
  }

  h1, h2 {
    letter-spacing: -0.045em;
    text-wrap: balance;
  }

  h3, h4 {
    letter-spacing: -0.02em;
  }

  input, select, textarea {
    background-color: ${({ theme }) => theme.colors.surface};
  }

  a, button {
    -webkit-tap-highlight-color: transparent;
  }

  /* Acciones de texto legibles en toda la experiencia. Los controles que
     declaran aria-label son botones de icono y conservan su escala compacta. */
  button:not([aria-label]) {
    font-size: max(1rem, 16px) !important;
  }

  :focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: 3px;
  }

  main:focus {
    outline: none;
  }

  ::selection {
    background: rgba(47, 112, 136, 0.18);
    color: #24353b;
  }

  img, svg, video, canvas {
    max-width: 100%;
  }

  /* Google Maps controla internamente el tamaño de mosaicos, iconos y SVG. */
  .gm-style img,
  .gm-style svg {
    max-width: none !important;
  }

  .gm-style button {
    max-width: none;
  }

  button, input, select, textarea {
    max-width: 100%;
    color: inherit;
  }
`;
